import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=2cb5709a&scoped=true&"
import script from "./Course.vue?vue&type=script&lang=ts&"
export * from "./Course.vue?vue&type=script&lang=ts&"
import style0 from "./Course.vue?vue&type=style&index=0&id=2cb5709a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb5709a",
  null
  
)

export default component.exports